import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';

import usePageTitle from '../../hooks/usePageTitle';

import { ROUTER_TYPES } from '../../utils/constants';

import TypoContainer from '../../uikit/TypoContainer';

import type { SpeakerContractQuery$key } from './__generated__/SpeakerContractQuery.graphql';

import Breadcrumns from '../../uikit/Breadcrumbs';

interface Props {
	query: SpeakerContractQuery$key | null;
}

function SpeakerContract(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const data: any = useFragment(
		graphql`
			fragment SpeakerContractQuery on HomePublishedContent {
				_children {
					items {
						... on FormPagePublishedContent {
							_children {
								items {
									... on ContentPagePublishedContent {
										metaTitle
										title
										content
										... on SimplePagePublishedContent {
											pageName
										}
									}
								}
							}
						}
					}
				}
			}
		`,
		props.query
	);
	const [fetchedData, setFetchedData] = useState<{
		title: string;
		content: string;
		metaTitle: string;
	}>();

	useEffect(() => {
		data._children.items.map(
			(item: {
				_children: {
					items: {
						metaTitle: string;
						title: string;
						content: string;
						pageName: string;
					}[];
				};
			}) => {
				if (item && Object.keys(item).length !== 0) {
					item._children.items?.map((innerItem) => {
						if (innerItem && innerItem.pageName === 'speakers-contract') {
							setFetchedData(innerItem);
						}
					});
				}
			}
		);
	}, [data]);
	usePageTitle(fetchedData?.metaTitle);
	return (
		<div className="policy-page">
			<Container>
				<Row>
					{fetchedData && (
						<>
							<Col xs={12}>
								<Breadcrumns
									parentLabel="Become a speaker"
									parentLink={ROUTER_TYPES.becomeSpeaker}
									currentPage={fetchedData.title}
								/>
							</Col>
							<Col xs={12} lg={9} className="policy-page__heading">
								<h1 className="uikit-heading-hg">{fetchedData.title}</h1>
							</Col>
							<Col xs={12} lg={8} className="policy-page__content">
								{fetchedData.content && (
									<TypoContainer markup={fetchedData.content} />
								)}
							</Col>
						</>
					)}
				</Row>
			</Container>
		</div>
	);
}

export default SpeakerContract;
